var map = {
	"./text_off.svg": "./src/assets/roomType/lms/img/text_off.svg",
	"./text_on.svg": "./src/assets/roomType/lms/img/text_on.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/roomType/lms/img sync recursive ^\\.\\/text_.*\\.svg$";